import { BRAND_VIEW_SECTION_TYPES, SPACE_VIEW_TYPES } from 'homepage/enums/contentConstants';

export const filterSections = (sections = [], isMobile) => {
  const viewportSections = [];

  for (const section of sections) {
    if (section?.type === BRAND_VIEW_SECTION_TYPES.VIDEO_HERO_SECTION) {
      const asset = section?.videos?.[0];
      const { aspect } = asset;
      const isPortrait = aspect < 1;

      if (isPortrait && isMobile) {
        viewportSections.push(section);
      }

      if (!isPortrait && !isMobile) {
        viewportSections.push(section);
      }
    } else if (section?.type === BRAND_VIEW_SECTION_TYPES.SPACE_ARTICLE_SECTION) {
      if (
        isMobile &&
        section?.articles?.some((article) => article?.viewType === SPACE_VIEW_TYPES.MOBILE_VIEW)
      ) {
        // only include sections that have at least 1 mobile view
        viewportSections.push(section);
      } else if (
        !isMobile &&
        section?.articles?.some((article) => article?.viewType === SPACE_VIEW_TYPES.DESKTOP_VIEW)
      ) {
        // only include sections that have at least 1 desktop view
        viewportSections.push(section);
      }
    } else {
      viewportSections.push(section);
    }
  }

  return viewportSections;
};
